































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { Employer } from "@/admin/types";
import {
  EmployerEditSuppressionType,
  UserPermission,
} from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployerStore } from "@/admin/store/employer";
import { useSalesPersonStore } from "@/admin/store/salesPerson";
import { usePartnerSettingStore } from "@/shared/store/partnerSetting";
import { useOpenSearchIndexStore } from "@/admin/store/openSearchIndex";

@Component({
  components: {
    Input,
    Button,
    EmployerPhone,
    ErrorSummary
  }
})

export default class EmployerDetails extends Vue {
  $router: VueRouter;
  $validator: Validator;
  EmployerEditSuppressionType = EmployerEditSuppressionType;

  @Prop() employerId: number;

  featureFlagStore = useFeatureFlagStore();
  rolePermissions = useRolePermissionsStore();
  notifierStore = useNotifierStore();
  employerStore = useEmployerStore();
  salesPersonStore = useSalesPersonStore();
  partnerSettingStore = usePartnerSettingStore();
  openSearchIndexStore = useOpenSearchIndexStore();

  employerName = "";
  employerPhone = "";
  employerSalesPerson = 0;
  partnerId = 0;
  hubspotId = "";
  isTalonDisabledForPartner = false;
  allowHealthPlanSyncOverride = false;
  currentOverridSetting = false;
  partnerName = "";
  isLoaded = false;
  isSubmitting = false;

  mounted (): void {
    this.salesPersonStore.getSalesPersons();
    this.onEmployerIdChanged();
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
        ? this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit)
        : true;
  }

  @Watch("employerStore.employers", { deep: true })
  onEmployerIdChanged () {
    if (this.isSubmitting) {
      return;
    }
    if (this.employerId) {
      this.isLoaded = false;
      this.employerStore.loadEmployer(this.employerId);
      if (this.employer) {
        this.employerName = this.employer.name;
        this.employerPhone = this.employer.phone;
        this.employerSalesPerson = this.employer.salesPersonId;
        this.hubspotId = this.employer.hubspotId;
        this.partnerId = this.employer.partner.id;
        this.isTalonDisabledForPartner = this.employer.partner.isTalonDisabledForPartner;
        this.partnerName = this.employer.partner.name;
        this.allowHealthPlanSyncOverride = this.employer.allowHealthPlanSyncOverride;
        this.currentOverridSetting = this.employer.allowHealthPlanSyncOverride;
        this.partnerSettingStore.loadPartnerSettings(this.partnerId);
      }
      this.isLoaded = true;
    } else {
      this.isLoaded = true;
      this.employerName = "";
      this.employerPhone = "";
      this.employerSalesPerson = 0;
      this.hubspotId = "";
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.isSubmitting = true;
          this.employer.name = this.employerName;
          this.employer.phone = this.employerPhone;
          this.employer.salesPersonId = this.employerSalesPerson;
          this.employer.hubspotId = this.hubspotId;
          this.employer.allowHealthPlanSyncOverride = this.allowHealthPlanSyncOverride;
          this.employerStore.updateEmployer(this.employer)
              .then(result => {
                this.isSubmitting = false;
                this.notifierStore.setSuccess(this.employerName + " updated");
              })
              .catch(err => {
                if (err && err.message) {
                  this.notifierStore.setDanger(err.message);
                } else {
                  this.notifierStore.setDanger("Employer was not updated");
                }
                this.isSubmitting = false;
              });
        });
  }

  get employer (): Employer {
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    return loadedEmployer.employer;
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get terminationProcessDate () {
    return moment(this.employer.dateTerminated).format("MMM DD, YYYY");
  }

  get terminationEffectiveDate () {
    return moment(this.employer.dateTerminationEffective).format("MMM DD, YYYY");
  }

  get editDisabled () {
    return this.partnerSettingStore.settings && this.partnerSettingStore.settings.employerEditSuppressionType
        === EmployerEditSuppressionType.HsaBankImportedProperties;
  }
  onReindex () {
    this.openSearchIndexStore.reindexEmployer(this.employerId);
  }
}
